import { render, staticRenderFns } from "./MyList1.vue?vue&type=template&id=060b6e3c&scoped=true&"
import script from "./MyList1.vue?vue&type=script&lang=js&"
export * from "./MyList1.vue?vue&type=script&lang=js&"
import style0 from "./MyList1.vue?vue&type=style&index=0&id=060b6e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b6e3c",
  null
  
)

export default component.exports